import type { ComponentProps } from "react"
import { cn } from "cn"

export type SkeletonProps = ComponentProps<"div">

/**
 * Platzhalter für ladende Inhalte. Figma zeigt nur eine Fläche (250×125) —
 * die Größe wird daher vom Konsumenten per `className` bestimmt
 * (z. B. `h-4 w-40`, `size-10 rounded-full`).
 */
function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "animate-pulse overflow-clip rounded-xl bg-neutrals-v2-300",
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
